import React from 'react'
import { Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { routes } from '../../routes'
import { useLocationScroll } from '../../hooks'
import { mtUrlMap } from '../../hooks/useExternalApp'

const InternalLink = ({ ...props }) => (
  <Link component={RouterLink} {...props} />
)

const AcceptableUseLink = ({ ...props }) => (
  <InternalLink
    to={{ pathname: routes.tandc.path, hash: '#acceptableuse' }}
    data-test='acceptable-use-policy-link'
    {...props}
  >
    {props.children || 'Acceptable Use Policy'}
  </InternalLink>
)

const PrivacyPolicyLink = ({ ...props }) => (
  <Link
    href={mtUrlMap.privacy}
    target='_blank'
    rel='noreferrer'
    data-test='privacy-policy-link'
    {...props}
  >
    {props.children || 'Privacy Policy'}
  </Link>
)

const TandCLink = ({ ...props }) => (
  <Link
    href={mtUrlMap.tandc}
    target='_blank'
    rel='noreferrer'
    data-test='tandc-link'
    {...props}
  >
    {props.children || 'Terms of Website Use'}
  </Link>
)

const ContactLink = ({ ...props }) => (
  <Link
    href={mtUrlMap.contact}
    target='_blank'
    rel='noreferrer'
    data-test='contact-page-link'
    {...props}
  >
    {props.children}
  </Link>
)

const CookiesPolicyLink = ({ ...props }) => (
  <Link
    href={mtUrlMap.cookie}
    target='_blank'
    rel='noreferrer'
    data-test='cookies-policy-link'
    {...props}
  >
    {props.children || 'Cookies Policy'}
  </Link>
)

const A11yStatementLink = ({ ...props }) => (
  <InternalLink
    to={routes['a11y-statement'].path}
    state={{ [useLocationScroll.SCROLLTOP]: true }}
    data-test='a11y-statement-link'
    {...props}
  >
    {props.children || 'Accessibility Statement'}
  </InternalLink>
)

export {
  AcceptableUseLink,
  ContactLink,
  CookiesPolicyLink,
  PrivacyPolicyLink,
  TandCLink,
  A11yStatementLink
}
